import { UserRole } from "@/common/types/users";

export const transformNewRoles = (role: { value?: string; }) => ({
  role_id: role.value,
});

export const transformRolesToOptions = (userRoles: UserRole[]) => (
  userRoles.map((userRole) => ({ label: userRole.role.display_name, value: userRole.role.id }))
);
